import React from 'react';
import Button from '@mui/material/Button';

import { userList } from '../selectors/users';
import { useAppSelector } from './hooks';

export function CsvExport() {
  const allUsers = useAppSelector(userList);

  const exportCsv = () => {
    const csvContent = [
      ['firstname', 'lastname', 'email', 'phone', 'organization', 'role_set', 'location', 'password'],
    ];
    for (let i = 0; i < allUsers.length; i++) {
      const userArray = [];
      userArray.push(allUsers[i].firstName);
      userArray.push(allUsers[i].lastName);
      userArray.push(allUsers[i].email);
      userArray.push(allUsers[i].phone);
      userArray.push(allUsers[i].organization);
      userArray.push(JSON.stringify(allUsers[i].roleSet).replace(/"/g, '""'));
      userArray.push(allUsers[i].location);
      userArray.push('Hidden');
      csvContent.push(userArray);
    }
    // convert array object into csv style text file
    let finalVal = '';
    for (let i = 0; i < csvContent.length; i++) {
      const value = csvContent[i];

      for (let j = 0; j < value.length; j++) {
        const innerValue = value[j];
        if (j > 0) {
          finalVal += ',';
        }
        finalVal += `"${innerValue}"`;
      }

      finalVal += '\n';
    }

    const pom = document.createElement('a');
    pom.setAttribute('href', `data:text/csv;charset=utf-8,${encodeURIComponent(finalVal)}`);
    pom.setAttribute('download', 'users.csv');
    pom.click();
  };

  return (
    <Button sx={{ width: '100%', mr: 1 }} size="small" variant="outlined" onClick={exportCsv}>
      Export Users
    </Button>
  );
}
